import React, { useContext, useEffect, FC } from 'react';
import { useParams } from 'react-router-dom';
import { Menu, Drawer } from 'antd';
import uniqid from 'uniqid';
import UserFragment from '../UserFragment';
import { Link } from 'react-router-dom';
import { SearchContext } from 'app/contexts/SearchContext';
import { NavigationContext } from 'app/contexts/NavigationContext';
import { SideBarProps } from './models.d';

import './SideBar.scss';

const SideBar: FC<SideBarProps> = ({ menuItems }) => {
  const { socialLinks } = useContext(SearchContext);
  const { isSideBar, closeSideBar } = useContext(NavigationContext);
  const { SubMenu } = Menu;
  let { slug } = useParams<{ slug: string }>();

  const socialUrlsRender = socialLinks?.map(({ link, icon }, index) => (
    <a href={link} target="_blank" rel="noreferrer" key={index}>
      <img src={icon} alt="social-icon" className="footer__social-link" />
    </a>
  ));

  const menuRender = (
    <Menu mode="inline">
      {menuItems?.map(item =>
        item.path || item.page ? (
          item.path ? (
            <Menu.Item key={uniqid()}>
              <Link to={`/${item.path}`}>{item.name}</Link>
            </Menu.Item>
          ) : item.page ? (
            <Menu.Item key={uniqid()}>
              <Link to={`/${item.page.slug}`}>{item.name}</Link>
            </Menu.Item>
          ) : null
        ) : item.children.length ? (
          <SubMenu key={uniqid()} title={item.name}>
            {item.children?.map(itemSub =>
              itemSub.path || itemSub.page ? (
                itemSub.path ? (
                  <Menu.Item key={uniqid()}>
                    <Link to={`/${itemSub.path}`}>{itemSub.name}</Link>
                  </Menu.Item>
                ) : itemSub.page ? (
                  <Menu.Item key={uniqid()}>
                    <Link to={`/${itemSub.page.slug}`}>{itemSub.name}</Link>
                  </Menu.Item>
                ) : null
              ) : itemSub.children.length ? (
                <SubMenu key={uniqid()} title={itemSub.name}>
                  {itemSub.children?.map(itemSubSecond =>
                    itemSubSecond.path || itemSubSecond.page ? (
                      itemSubSecond.path ? (
                        <Menu.Item key={uniqid()}>
                          <Link to={`/${itemSubSecond.path}`}>
                            {itemSubSecond.name}
                          </Link>
                        </Menu.Item>
                      ) : itemSubSecond.page ? (
                        <Menu.Item key={uniqid()}>
                          <Link to={`/${itemSubSecond.page.slug}`}>
                            {itemSubSecond.name}
                          </Link>
                        </Menu.Item>
                      ) : null
                    ) : null,
                  )}
                </SubMenu>
              ) : null,
            )}
          </SubMenu>
        ) : null,
      )}
    </Menu>
  );

  useEffect(() => {
    closeSideBar();
  }, [slug]);

  return (
    <Drawer
      className="side-bar"
      placement="left"
      key="left"
      closable={true}
      onClose={closeSideBar}
      visible={isSideBar}
      maskStyle={{ opacity: 0 }}
      closeIcon={false}
    >
      {menuRender}
      <div className="side-bar__btns">
        <UserFragment variant="sidebar" />
      </div>
      <div className="side-bar__social-links">{socialUrlsRender}</div>
    </Drawer>
  );
};

export default SideBar;
